import { render, staticRenderFns } from "./BasicBox.vue?vue&type=template&id=3df1b1ee&scoped=true"
import script from "./BasicBox.vue?vue&type=script&lang=js"
export * from "./BasicBox.vue?vue&type=script&lang=js"
import style0 from "./BasicBox.vue?vue&type=style&index=0&id=3df1b1ee&prod&lang=scss&scoped=true"
import style1 from "./BasicBox.vue?vue&type=style&index=1&id=3df1b1ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df1b1ee",
  null
  
)

export default component.exports